import { Fragment } from "react";

import AssetList from "../AssetList";
import AssetFloor from "./AssetFloor";

function FloorView() {
  return (
    <Fragment>
      <AssetFloor />
      <AssetList floorview={true}/>
    </Fragment>
  );
}

export default FloorView;
